<template>
  <div class="subdomain-settings ">
    <h3 class="brdr_content_title">Funnelish™ subdomain</h3>
    <loading v-show="loading"></loading>
    <div class="layout-row clickable-section" @click="openPopup = true">
      <div class="flex">
        <p style="font-weight: 600;">Your Funnelish™ Subdomain</p>
        <p>
	        This is your default domain name, it's ideal for testing however it's not recommended for live funnels or to running ads.
        </p>
      </div>
	    <div class="flex">
	    </div>
      <div class="flex-none right-panel" style="min-width: 200px">
	      <span v-if="user.subdomain">
		      <b>{{ user.subdomain }}</b>.funnelish.com
	      </span>
	      <span v-else style="color: red;">
		      No subdomain set yet
	      </span>
      </div>
    </div>

	  <subdomain-popup v-if="openPopup" @close="openPopup=false" />

  </div>
</template>

<script>
import Loading from "@/components/Loading";
import API from "@/api"
import InputField from "@/components/base/input-field";
import SubdomainPopup from "@/components/popups/subdomain-popup";

export default {
    name: 'SubdomainSettings',
  props: [],
  mixins: [API],
  components: {SubdomainPopup, InputField, Loading},
  data: function (){
      return {
        loading: false,
        openPopup: false,
      }
  },
  computed: {
	  user() {
		  return this.$store.state.userInfo;
	  }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.subdomain-settings {
	.right-panel {
		margin: auto;
		color: #57585D;
		font-size: 14px;
		b {
			//color: black;
		}
	}
}
</style>
